// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.championship-details-page {
  display: grid;
  gap: 20px;
}

.championship-details-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.championship-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 8px 0 4px;
}

.championship-title-row h1 {
  margin: 0;
}

.championship-header-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 10px;
  min-width: min(420px, 100%);
}

.summary-card {
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px 14px;
  display: grid;
  gap: 4px;
}

.summary-label {
  color: var(--muted);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.registration-actions-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.muted-copy {
  color: var(--muted);
  font-size: 0.9rem;
}

.championship-details-shell {
  display: grid;
  gap: 20px;
  min-width: 0;
}

/* Prevent grid children from expanding the cell beyond container width,
   so table-shell's overflow-x:auto can actually scroll on narrow screens. */
.championship-details-shell > * {
  min-width: 0;
}

.tab-switch-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tab-switch {
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--text);
  border-radius: 999px;
  padding: 8px 14px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.tab-switch.active,
.tab-switch:hover {
  background: var(--button-bg);
  color: var(--button-text);
  border-color: var(--button-border);
}

.info-grid {
  display: grid;
  gap: 16px;
}

.info-panel {
  display: grid;
  gap: 10px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: linear-gradient(180deg, var(--surface) 0%, var(--surface-strong) 100%);
}

.info-panel h3,
.info-panel h4 {
  margin: 0;
  color: var(--text);
}

.info-panel p,
.info-panel li {
  color: var(--muted);
  line-height: 1.6;
}

.pit-stop-rules {
  display: inline-flex;
  align-items: center;
  gap: 9px;
}

.pit-stop-icon {
  position: relative;
  display: inline-flex;
  color: var(--text);
}

.pit-stop-icon.is-disabled {
  color: var(--muted);
}

.pit-stop-icon-strike {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 125%;
  height: 1.5px;
  background: currentColor;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.pit-window-badge {
  padding: 2px 6px;
  border: 1px solid currentColor;
  border-radius: 4px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.3;
}

.info-list {
  display: grid;
  gap: 10px;
  padding-left: 18px;
  margin: 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.stat-tile {
  padding: 14px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--surface);
  display: grid;
  gap: 4px;
}

.stat-label {
  color: var(--muted);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.stat-value {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
}

.table-shell {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  min-width: 0;
  max-width: 100%;
}

.standings-table th,
.standings-table td,
.drivers-table th,
.drivers-table td {
  padding: 12px 14px;
  white-space: nowrap;
}

.standings-table th,
.drivers-table th {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.vertical-header {
  min-height: 118px;
  display: flex;
  justify-content: center;
  align-items: center;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
}

.round-card {
  border: 1px solid var(--border);
  border-radius: 16px;
  background: linear-gradient(180deg, var(--surface) 0%, var(--surface-strong) 100%);
  padding: 16px;
  display: grid;
  gap: 14px;
}

.round-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.round-card-title {
  display: grid;
  gap: 4px;
}

.round-card-title h3 {
  margin: 0;
  font-size: 1rem;
}

.round-card-title p {
  margin: 0;
  color: var(--muted);
}

.round-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--muted-strong);
  font-size: 0.82rem;
}

.round-card-body {
  display: grid;
  gap: 12px;
}

.round-card-toggle {
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
}

.round-card-toggle:hover .round-card-title h3 {
  color: var(--secondary-color, #4f46e5);
}

.chevron-icon {
  transition: transform 0.2s ease;
  color: var(--muted);
  flex-shrink: 0;
}

.chevron-icon.rotated {
  transform: rotate(180deg);
}

.access-details {
  display: grid;
  gap: 4px;
  font-size: 0.9rem;
  color: var(--text);
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface);
}

.access-details-header {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--muted);
  margin-bottom: 2px;
}

.access-password-value {
  font-family: monospace;
}

.access-password-toggle {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 2px 4px;
  vertical-align: middle;
}

.access-details-locked {
  margin: 0;
  font-size: 0.85rem;
  color: var(--muted);
  font-style: italic;
}

.session-actions-group {
  display: grid;
  gap: 8px;
}

.session-actions-header {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--muted);
}

.session-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.session-action-button {
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--text);
  border-radius: 999px;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: not-allowed;
  opacity: 0.65;
}

.session-action-button.enabled {
  cursor: pointer;
  opacity: 1;
}

.session-action-button.enabled:hover {
  background: var(--button-bg);
  color: var(--button-text);
  border-color: var(--button-border);
}

.session-action-duration {
  font-size: 0.78rem;
  color: inherit;
  opacity: 0.9;
}

.event-collapsed-meta {
  font-size: 0.82rem;
  color: var(--muted);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .championship-details-header {
    flex-direction: column;
    margin-bottom: 0px !important;
  }

  .championship-header-summary {
    min-width: 100%;
  }

  .event-collapsed-pill {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ChampionshipDetailsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;4EAC4E;AAC5E;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,4BAA4B;EAC5B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA;;EAEE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kFAAkF;EAClF,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".championship-details-page {\r\n  display: grid;\r\n  gap: 20px;\r\n}\r\n\r\n.championship-details-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.championship-title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin: 8px 0 4px;\r\n}\r\n\r\n.championship-title-row h1 {\r\n  margin: 0;\r\n}\r\n\r\n.championship-header-summary {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(120px, 1fr));\r\n  gap: 10px;\r\n  min-width: min(420px, 100%);\r\n}\r\n\r\n.summary-card {\r\n  background: var(--surface-strong);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 12px 14px;\r\n  display: grid;\r\n  gap: 4px;\r\n}\r\n\r\n.summary-label {\r\n  color: var(--muted);\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.registration-actions-row {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.muted-copy {\r\n  color: var(--muted);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.championship-details-shell {\r\n  display: grid;\r\n  gap: 20px;\r\n  min-width: 0;\r\n}\r\n\r\n/* Prevent grid children from expanding the cell beyond container width,\r\n   so table-shell's overflow-x:auto can actually scroll on narrow screens. */\r\n.championship-details-shell > * {\r\n  min-width: 0;\r\n}\r\n\r\n.tab-switch-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.tab-switch {\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  border-radius: 999px;\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.tab-switch.active,\r\n.tab-switch:hover {\r\n  background: var(--button-bg);\r\n  color: var(--button-text);\r\n  border-color: var(--button-border);\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  gap: 16px;\r\n}\r\n\r\n.info-panel {\r\n  display: grid;\r\n  gap: 10px;\r\n  padding: 16px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  background: linear-gradient(180deg, var(--surface) 0%, var(--surface-strong) 100%);\r\n}\r\n\r\n.info-panel h3,\r\n.info-panel h4 {\r\n  margin: 0;\r\n  color: var(--text);\r\n}\r\n\r\n.info-panel p,\r\n.info-panel li {\r\n  color: var(--muted);\r\n  line-height: 1.6;\r\n}\r\n\r\n.pit-stop-rules {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n}\r\n\r\n.pit-stop-icon {\r\n  position: relative;\r\n  display: inline-flex;\r\n  color: var(--text);\r\n}\r\n\r\n.pit-stop-icon.is-disabled {\r\n  color: var(--muted);\r\n}\r\n\r\n.pit-stop-icon-strike {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  width: 125%;\r\n  height: 1.5px;\r\n  background: currentColor;\r\n  transform: translate(-50%, -50%) rotate(-45deg);\r\n}\r\n\r\n.pit-window-badge {\r\n  padding: 2px 6px;\r\n  border: 1px solid currentColor;\r\n  border-radius: 4px;\r\n  color: var(--muted);\r\n  font-size: 12px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.info-list {\r\n  display: grid;\r\n  gap: 10px;\r\n  padding-left: 18px;\r\n  margin: 0;\r\n}\r\n\r\n.stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.stat-tile {\r\n  padding: 14px;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface);\r\n  display: grid;\r\n  gap: 4px;\r\n}\r\n\r\n.stat-label {\r\n  color: var(--muted);\r\n  font-size: 0.8rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: var(--text);\r\n}\r\n\r\n.table-shell {\r\n  overflow-x: auto;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--surface);\r\n  min-width: 0;\r\n  max-width: 100%;\r\n}\r\n\r\n.standings-table th,\r\n.standings-table td,\r\n.drivers-table th,\r\n.drivers-table td {\r\n  padding: 12px 14px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.standings-table th,\r\n.drivers-table th {\r\n  font-size: 0.8rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.vertical-header {\r\n  min-height: 118px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  writing-mode: vertical-rl;\r\n  transform: rotate(180deg);\r\n  white-space: nowrap;\r\n}\r\n\r\n.round-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  background: linear-gradient(180deg, var(--surface) 0%, var(--surface-strong) 100%);\r\n  padding: 16px;\r\n  display: grid;\r\n  gap: 14px;\r\n}\r\n\r\n.round-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.round-card-title {\r\n  display: grid;\r\n  gap: 4px;\r\n}\r\n\r\n.round-card-title h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n.round-card-title p {\r\n  margin: 0;\r\n  color: var(--muted);\r\n}\r\n\r\n.round-card-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.meta-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 7px 10px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface);\r\n  color: var(--muted-strong);\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.round-card-body {\r\n  display: grid;\r\n  gap: 12px;\r\n}\r\n\r\n.round-card-toggle {\r\n  width: 100%;\r\n  text-align: left;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  color: inherit;\r\n}\r\n\r\n.round-card-toggle:hover .round-card-title h3 {\r\n  color: var(--secondary-color, #4f46e5);\r\n}\r\n\r\n.chevron-icon {\r\n  transition: transform 0.2s ease;\r\n  color: var(--muted);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chevron-icon.rotated {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.access-details {\r\n  display: grid;\r\n  gap: 4px;\r\n  font-size: 0.9rem;\r\n  color: var(--text);\r\n  padding: 10px 12px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface);\r\n}\r\n\r\n.access-details-header {\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  color: var(--muted);\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.access-password-value {\r\n  font-family: monospace;\r\n}\r\n\r\n.access-password-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  margin-left: 6px;\r\n  padding: 2px 4px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.access-details-locked {\r\n  margin: 0;\r\n  font-size: 0.85rem;\r\n  color: var(--muted);\r\n  font-style: italic;\r\n}\r\n\r\n.session-actions-group {\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.session-actions-header {\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  color: var(--muted);\r\n}\r\n\r\n.session-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.session-action-button {\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  border-radius: 999px;\r\n  padding: 8px 12px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: not-allowed;\r\n  opacity: 0.65;\r\n}\r\n\r\n.session-action-button.enabled {\r\n  cursor: pointer;\r\n  opacity: 1;\r\n}\r\n\r\n.session-action-button.enabled:hover {\r\n  background: var(--button-bg);\r\n  color: var(--button-text);\r\n  border-color: var(--button-border);\r\n}\r\n\r\n.session-action-duration {\r\n  font-size: 0.78rem;\r\n  color: inherit;\r\n  opacity: 0.9;\r\n}\r\n\r\n.event-collapsed-meta {\r\n  font-size: 0.82rem;\r\n  color: var(--muted);\r\n  margin: 0;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .championship-details-header {\r\n    flex-direction: column;\r\n    margin-bottom: 0px !important;\r\n  }\r\n\r\n  .championship-header-summary {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .event-collapsed-pill {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
